module.exports = __webpack_public_path__ + "img/ps-xau-example.4f32f9e5.png";